import { render, staticRenderFns } from "./CodeTest.vue?vue&type=template&id=1b1a97de&scoped=true"
import script from "./CodeTest.vue?vue&type=script&lang=js"
export * from "./CodeTest.vue?vue&type=script&lang=js"
import style0 from "./CodeTest.vue?vue&type=style&index=0&id=1b1a97de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b1a97de",
  null
  
)

export default component.exports